import {getUrlParam} from '../utils/url';

const selectors = {
  sortSelection: '.js-sort',
};

const filter = document.querySelector(selectors.sortSelection);

if (filter !== undefined && filter !== null) {
  filter.addEventListener('change', () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.set(filter.getAttribute('name'), filter.value);
    window.location = `?${urlSearchParams}`;
  });
}
